<script lang="ts">
    import {FontStyle} from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Card cardHeaderprops="pb-0" headerTitle={FontStyle}>
    <div slot="contentbody">
        <pre class="helper-classes">
            {`.f-s-normal {
            font-style: normal;
            }
            .f-s-italic {
            font-style: italic;
            }
            .f-s-oblique {
            font-style: oblique;
            }
            .f-s-initial {
            font-style: initial;
            }
            .f-s-inherit {
            font-style: inherit;
            }`}
        </pre>
    </div>
</Card>